import axios from 'axios'
// import store from '@/store'
import { getToken } from '@/utils/auth'
import { delCookie, getCookie } from '@/utils/cookie' // getToken from cookie
import { chkLogin } from "@/api/login"
// create an axios instance
// const service = axios.create({
// baseURL: 'https://trade.reflower.com.cn', // url = base url + request url
//   withCredentials: true, // send cookies when cross-domain requests
//   timeout: 50000 ,// request timeout

// })
axios.defaults.timeout = 30000
// axios.defaults.baseURL = 'https://trade-ce.reflower.com.cn'
// axios.defaults.baseURL = 'https://trade.reflower.com.cn'
if (process.env.NODE_ENV == 'test') {
  axios.defaults.baseURL = 'https://trade-ce.reflower.com.cn'
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://trade.reflower.com.cn'
}
axios.defaults.headers.common['From'] = "H5";
axios.defaults.withCredentials = true
// request interceptor
axios.interceptors.request.use(
  config => {
    // do something before request is sent
     // determine if there has token
    	/* has token*/
    	// config.headers['X-Token'] = getToken()

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {

    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if(res.code == "229"){
      chkLogin();
      return;
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js